import _extends from "@babel/runtime/helpers/extends";
import { TextButton } from '@wix/design-system';
import React from 'react';
export const CheckoutDisclaimerLink = _ref => {
  let {
    url,
    isMobile = false,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(TextButton, _extends({
    as: "a",
    href: url,
    target: "_blank",
    size: "tiny",
    skin: "dark",
    underline: "always"
  }, isMobile ? {
    weight: 'normal'
  } : {}), children);
};
//# sourceMappingURL=CheckoutDisclaimerLink.js.map